import { EntityStatusEnum } from '@d-constants';

export interface SortByConfig {
  fieldName: string;
  ascending: boolean;
}

export interface BaseSearchRequest {
  pageIndex?: number;
  rowPerPage?: number;
  sortBy?: SortByConfig[];
  searchGlobal?: {
    filterBy: string;
    searchBy: string;
  } | null;
  advancedFilter?: { [key: string]: any } | null;
  level?: number;
  programOwnerId?: string;
  productId?: string;
  historyImportId?: string;
  statuses?: number[];
  approvalFlowStatuses?: number[];
  merchantStatuses?: number[];
  onlyShowLatestRevision?: boolean;
  programmeTypeIds?: string[];
}

export interface SearchRequest {
  pageIndex?: number;
  pageSize: number;
  sortBy?: SortByConfig[];
  searchGlobal?: {
    filterBy: string;
    searchBy: string;
  } | null;
  advancedFilter?: { [key: string]: any } | null;
  programOwnerId?: string | null;
  productId?: string | null;
  statuses?: number[] | null;
  approvalFlowStatuses?: number[];
  historyImportId?: string | null;
}

export interface BaseSearchResponseDataModel<T> {
  numOfPages: number;
  numOfRecords: number;
  pageIndex: number;
  data: T[];
}

export interface BaseSearchResponseModel<T> {
  isSuccess: boolean;
  messages: { content: string; type: number }[];
  data: BaseSearchResponseDataModel<T>;
}

export interface BaseResponseModel<T> {
  isSuccess: boolean;
  messages: { content: string; type: number }[];
  data: T;
}

export abstract class BaseModel {
  id: string;

  constructor(value: any) {
    this.id = value.id;
  }
}

export class BaseAttachmentModel {
  id?: string;
  size?: number;
  name: string;
  attachmentUrl?: string;
  viewAttachmentUrl: string;
  constructor(data: any) {
    this.id = data.id;
    this.size = 0;
    this.name = data.attachmentName;
    this.attachmentUrl = data.attachmentUrl;
    this.viewAttachmentUrl = data.viewAttachmentUrl;
  }
}

export interface IAttachmentModel {
  id: string;
  attachmentName?: string;
  attachmentUrl?: string;
  viewAttachmentUrl?: string;
}

export class SimplifyProgrammeModel {
  id: string;
  programmeName: string;
  shortProgrammeName: string;

  constructor(data: any) {
    this.id = data?.id;
    this.programmeName = data?.programmeName;
    this.shortProgrammeName = data?.shortProgrammeName;
  }
}

export class DummyModel extends BaseModel {}

export interface IRecord {
  id: string;
  status: EntityStatusEnum;
  updatedDateTime: string;
  updatedUtcDateTime: number;
  updatedBy: string;
  createdDateTime: string;
  createdUtcDateTime: number;
  createdBy: string;

  remarks?: string;
  tenantId?: string;
  deleted?: boolean;
}

export class RecordModel implements IRecord {
  id: string;
  status: EntityStatusEnum;
  updatedDateTime: string;
  updatedUtcDateTime: number;
  updatedBy: string;
  createdDateTime: string;
  createdUtcDateTime: number;
  createdBy: string;

  remarks?: string;
  tenantId?: string;
  deleted?: boolean;

  constructor(data: IRecord) {
    this.id = data.id;
    this.status = data.status;
    this.updatedDateTime = data.updatedDateTime;
    this.updatedUtcDateTime = data.updatedUtcDateTime;
    this.updatedBy = data.updatedBy;
    this.createdDateTime = data.createdDateTime;
    this.createdUtcDateTime = data.createdUtcDateTime;
    this.createdBy = data.createdBy;
    this.remarks = data.remarks;
    this.tenantId = data.tenantId;
    this.deleted = data.deleted;
  }
}

export interface ICoreResponse<DataType> {
  data: DataType;
  success: boolean;
  error: any[];
  errors: any;
  recordId: string | null;
}

export type IBaseAuditModel<T extends {}> = T & {
  createdDateTime: string;
  updatedDateTime: string;
  createdUtcDateTime: number;
  updatedUtcDateTime: number;
  createdBy: string;
  updatedBy: string;
};

export class BaseAuditModel<T> {
  createdDateTime: string;
  updatedDateTime: string;
  createdUtcDateTime: number;
  updatedUtcDateTime: number;
  createdBy: string;
  updatedBy: string;

  constructor(data: IBaseAuditModel<T>) {
    Object.assign(this, data);
  }
}

export class DownloadResponse {
  path: string;

  constructor(data: any) {
    this.path = data.path;
  }
}
